<!-- Secondary header: back button + title -->
<div
    class="flex h-13 w-full flex-0 items-center gap-4 bg-accent px-2 shadow print:hidden"
    *transloco="let t"
>
    <button
        mat-icon-button
        (click)="back()"
        aria-label="Go back"
    >
        <mat-icon class="text-white" svgIcon="heroicons_outline:arrow-left"></mat-icon>
    </button>

    <span class="text-lg font-semibold text-white">
        {{ t(titleKey) }}
    </span>
</div>
